
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import { GetStaticProps } from 'next';
import { AvailableProfileManager } from 'modules/App/server';
import HeaderLayout from 'modules/common/layouts/HeaderLayout';
import Hero from 'modules/common/components/Hero';
import { useAuthModal } from 'modules/auth';
import dbConnect from 'utils/db';
import { AvailableProfile } from 'modules/App/interfaces';
import CVThequeList from 'modules/App/components/CVThequeList';
import { Section } from '@/lib/components/layout/section';
import CVThequeCities from 'modules/App/components/CVThequeCities';
export interface CVThequeProps {
    availableProfiles: AvailableProfile[];
    cities: string[];
}
function CVTheque({ availableProfiles, cities }: CVThequeProps) {
    const { toggleModal } = useAuthModal();
    return (<HeaderLayout title={`CVthèque de ${availableProfiles.length} candidats Off-Market dispos immédiatement`} description="Tu as une mission parfaite pour un de ces candidats ? Propose-lui une mission et gagne la prime.">
      <Hero title={<>
            CVthèque de <span className="text-primary">{availableProfiles.length}</span> candidats Off-Market
            <br />
            disponibles <span className="">immédiatement</span>
          </>} description={<>
            Tu as mission parfaite pour un de ces candidats&nbsp;?
            <br />
            <strong className="link link-primary" onClick={() => toggleModal()}>
              Inscris-toi
            </strong>
            , <strong>propose ta mission</strong> et <strong>satisfais ton client</strong> plus rapidement.
          </>}/>
      <CVThequeList availableProfiles={availableProfiles}/>
      <Section className="bg-gray-50">
        <CVThequeCities cities={cities}/>
      </Section>
    </HeaderLayout>);
}
const getStaticProps: GetStaticProps<CVThequeProps> = async () => {
    await dbConnect();
    const { items: availableProfiles, cities } = await AvailableProfileManager.listNotConnected();
    return {
        props: {
            availableProfiles: JSON.parse(JSON.stringify(availableProfiles)),
            cities: JSON.parse(JSON.stringify(cities.map((city) => city.slug))),
        },
    };
};
export default CVTheque;

    async function __Next_Translate__getStaticProps__1989496f510__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/cvtheque/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1989496f510__ as getStaticProps }
  